import { ChangeMatchDate as ChangeMatchDateComponent } from './ChangeMatchDate.component';
import { connector } from './ChangeMatchDate.connector';

export const ChangeMatchDate = connector(ChangeMatchDateComponent);
